import React from 'react';
import { Database, X, ArrowRight } from 'lucide-react';

export interface NicheTemplatesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectNiche: (nicheKey: string) => Promise<void> | void;
  isLoading: boolean;
}

const NICHES = [
  {
    key: 'alimentacao',
    title: 'Alimentação & Cesta Básica',
    desc: 'Arroz, feijão, carnes, laticínios com alíquota zero e benefícios federais',
  },
  {
    key: 'saude',
    title: 'Saúde, Medicamentos & Clínicas',
    desc: 'Medicamentos essenciais, exames e consultas com redução legal de 60%',
  },
  {
    key: 'confeccao',
    title: 'Confecção, Calçados & Varejo Têxtil',
    desc: 'Alíquota padrão com crédito integral de insumos e matérias-primas',
  },
  {
    key: 'servicos_profissionais',
    title: 'Serviços & Profissões Regulamentadas',
    desc: 'Advocacia, contabilidade, engenharia com redução de 30% na CBS/IBS',
  },
  {
    key: 'bebidas_seletivo',
    title: 'Bebidas & Imposto Seletivo',
    desc: 'Cervejas, refrigerantes e produtos com incidência de Imposto Seletivo (+IS)',
  },
];

export default function NicheTemplatesModal({
  isOpen,
  onClose,
  onSelectNiche,
  isLoading,
}: NicheTemplatesModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-slate-900/60 backdrop-blur-xs flex items-center justify-center p-4">
      <div className="bg-white rounded-[28px] max-w-lg w-full border border-slate-200 shadow-2xl overflow-hidden p-6 sm:p-7 space-y-4 animate-in fade-in zoom-in-95 duration-150">
        
        {/* Cabeçalho */}
        <div className="flex items-center justify-between border-b border-slate-100 pb-3">
          <div className="flex items-center gap-2.5">
            <div className="w-9 h-9 rounded-2xl bg-emerald-100 text-emerald-900 flex items-center justify-center">
              <Database className="w-5 h-5 text-emerald-700" />
            </div>
            <div>
              <h3 className="text-sm font-black text-slate-900">
                Modelos Fiscais no Banco de Dados R-MAX
              </h3>
              <p className="text-[11px] text-slate-500">
                Selecione um segmento para carregar produtos (NCM) e serviços (NBS)
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="p-1 rounded-xl text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-colors cursor-pointer"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Lista de Nichos */}
        <div className="space-y-2 max-h-[60vh] overflow-y-auto">
          {NICHES.map((niche) => (
            <button
              key={niche.key}
              type="button"
              disabled={isLoading}
              onClick={() => onSelectNiche(niche.key)}
              className="w-full text-left p-3.5 rounded-2xl border border-slate-200 hover:border-emerald-500 hover:bg-emerald-50/40 transition-all flex items-center justify-between group cursor-pointer disabled:opacity-50"
            >
              <div>
                <strong className="text-xs font-black text-slate-900 group-hover:text-emerald-950 block">
                  {niche.title}
                </strong>
                <span className="text-[11px] text-slate-500 block mt-0.5">
                  {niche.desc}
                </span>
              </div>
              <ArrowRight className="w-4 h-4 text-slate-400 group-hover:text-emerald-700 shrink-0" />
            </button>
          ))}
        </div>

        {/* Rodapé M3 */}
        <div className="flex justify-end pt-2 border-t border-slate-100">
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="px-4 py-2 text-xs font-bold text-slate-600 hover:text-slate-900 cursor-pointer"
          >
            Fechar
          </button>
        </div>

      </div>
    </div>
  );
}
